import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=67b741f9&scoped=true&"
import script from "./Products.vue?vue&type=script&setup=true&lang=js&"
export * from "./Products.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=67b741f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b741f9",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
